module.exports = __webpack_public_path__ + "static/media/icon_power_point.4a6d1764.png";